/** @format */

// ACTION TYPES
export const UPDATE_TAB = 'general/UPDATE_TAB';

// ACTION CREATORS
export const updateTab = data => ({
  type: UPDATE_TAB,
  payload: data
});